import { FieldValues, FormState } from "react-hook-form";

const RootError = ({ formState }: { formState: FormState<FieldValues> }) => {
  return formState.errors.root?.message ? (
    <div className="bg-red-100 p-2 rounded-sm text-red-800 text-sm">
      {formState.errors.root.message}
    </div>
  ) : null;
};

export default RootError;
